import React from "react";
import { Link } from "react-router-dom";


export default function About() {
  return (
    <div>
        <div className="text-4xl">
            <h1>About</h1>
        </div>
    </div>
  );
}
